import { BottomSheet } from 'react-spring-bottom-sheet'
import styled from 'styled-components'
import { Colors } from '@styles/colors'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@store/selectors/utils'
import { setSamsungTerms } from '@store/modules/samsungTermsSlice'

interface Props {
  isOpen: boolean
  handleClose: () => void
  onClickEventParticipated: () => void
}
const Container = styled.section`
  padding: 40px 24px 0;
  background-color: ${Colors.gf};
  display: flex;
  flex-direction: column;
`
const Title = styled.h3`
  font-family: Pretendard700, sans-serif;
  font-size: 24px;
  line-height: 120%;
  margin-bottom: 24px;
  text-align: left;
`

const BottomButtonWrapper = styled.div`
  display: flex;
  padding: 16px 24px;
  margin-top: 24px;
  gap: 8px;
  & > button {
    outline: none;
    font-size: 16px;
    line-height: 120%;
    font-family: Pretendard400, sans-serif;
    width: 100%;
    height: 56px;
    color: ${Colors.gf};
    background-color: #0e6dfb;
    border-radius: 12px;
    &:disabled {
      background-color: #dcdeeb;
      color: #999ba9;
    }
  }
`
const TermsWrapper = styled.div`
  background-color: #f5f5f9;
  border: 1px solid #eaeef3;
  padding: 16px 8px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`

const TermsButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  gap: 8px;
  & > p {
    font-size: 18px;
    line-height: 120%;
    color: #19191b;
    font-family: Pretendard700, sans-serif;
  }
`
const Item = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  & > button {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`
const TermsText = styled.p`
  font-size: 16px;
  line-height: 120%;
`

const EventTermsBottomSheet = ({
  isOpen,
  handleClose,
  onClickEventParticipated,
}: Props) => {
  const dispatch = useAppDispatch()
  const termsState = useAppSelector((state) => state.samsungTermsReducer)
  const isAllAgree = useMemo(() => {
    return Object.values(termsState).every((s) => s)
  }, [termsState])
  const handleAllCheck = () => {
    const nextValue = !isAllAgree
    dispatch(
      setSamsungTerms({
        privacy: nextValue,
        thirdParty: nextValue,
      })
    )
  }
  const handleSingleCheck = (type: keyof typeof termsState) => {
    dispatch(
      setSamsungTerms({
        ...termsState,
        [type]: !termsState[type],
      })
    )
  }

  return (
    <>
      <BottomSheet open={isOpen} color={Colors.gf} onDismiss={handleClose}>
        <Container>
          <Title>확인해 주세요</Title>
          <TermsWrapper>
            <TermsButton onClick={handleAllCheck}>
              <img
                width={24}
                height={24}
                alt={isAllAgree ? '동의 철회하기' : '전체 동의하기'}
                src={
                  isAllAgree
                    ? '/icons/event/checkbox-active.png'
                    : '/icons/event/checkbox.png'
                }
              />

              <p>전체 동의</p>
            </TermsButton>
          </TermsWrapper>
          <ul>
            <Item>
              <button onClick={() => handleSingleCheck('privacy')}>
                <img
                  width={24}
                  height={24}
                  alt={termsState.privacy ? '동의 철회하기' : '동의하기'}
                  src={
                    termsState.privacy
                      ? '/icons/event/check-active.png'
                      : '/icons/event/check.png'
                  }
                />
                <TermsText>[필수] 개인정보 수집 및 이용 동의</TermsText>
              </button>

              <Link to={'/event/security/terms/privacy'}>
                <img
                  width={16}
                  height={16}
                  src={'/icons/event/arrow-right.png'}
                  alt={'navigate-to-terms'}
                />
              </Link>
            </Item>
            <Item>
              <button onClick={() => handleSingleCheck('thirdParty')}>
                <img
                  width={24}
                  height={24}
                  alt={termsState.thirdParty ? '동의 철회하기' : '동의하기'}
                  src={
                    termsState.thirdParty
                      ? '/icons/event/check-active.png'
                      : '/icons/event/check.png'
                  }
                />
                <TermsText>[필수] 개인정보 제3자 제공 동의</TermsText>
              </button>

              <Link to={'/event/security/terms/thirdParty'}>
                <img
                  width={16}
                  height={16}
                  src={'/icons/event/arrow-right.png'}
                  alt={'navigate-to-terms'}
                />
              </Link>
            </Item>
          </ul>
        </Container>

        <BottomButtonWrapper>
          <button disabled={!isAllAgree} onClick={onClickEventParticipated}>
            이자 받으러 가기
          </button>
        </BottomButtonWrapper>
      </BottomSheet>
    </>
  )
}

export default EventTermsBottomSheet
